import { useQuery, UseQueryOptions } from '@tanstack/react-query';
import { getAgencyRecommendations } from './api';
import { AgencyRecommendationsListResponse } from './types';

type RecommendationsQueryOptions = Omit<
  UseQueryOptions<AgencyRecommendationsListResponse, Error>,
  'queryKey' | 'queryFn'
>;

export function useGetAgencyRecommendations(params?: Record<string, unknown>, options?: RecommendationsQueryOptions) {
  return useQuery<AgencyRecommendationsListResponse>({
    queryKey: ['agency_recommendations', params],
    queryFn: () => getAgencyRecommendations(params),
    ...options
  });
}
